/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { IntegrationMethod, IntegrationStatus } from 'cio/models/setup-guide';
import AnalyticsService from 'cio/services/analytics';
import RouterService from '@ember/routing/router-service';
import { tracked } from '@glimmer/tracking';
import CustomFormsService from 'cio/services/custom-forms';
import CustomForm from 'cio/models/custom-form';
import DS from 'ember-data';
import { unixNowSeconds } from 'cio/utils/time';
import { task } from 'ember-concurrency';
import AuthService from 'cio/services/auth';

interface FormsSetupFormsCustomFormsArgs {
  setupGuideStatus?: IntegrationStatus;
  setupGuideOnSelect?: (method: IntegrationMethod, connectedAt: number) => void;
  onConnectForm?: (form: CustomForm) => unknown;
  source: string;
  isDuplicatingForm?: boolean;
}

export default class FormsSetupFormsCustomForms extends Component<FormsSetupFormsCustomFormsArgs> {
  @service auth!: AuthService;
  @service analytics!: AnalyticsService;
  @service router!: RouterService;
  @service store!: DS.Store;
  @service customForms!: CustomFormsService;

  @tracked customFormToConnect: CustomForm | null = null;

  @action
  connectCustomForm() {
    this.customFormToConnect = this.store.createRecord('custom-form');
  }

  @action
  cancelConnectForm() {
    if (this.customFormToConnect != null) {
      if (this.customFormToConnect.get('isNew')) {
        this.customFormToConnect.unloadRecord();
      } else {
        this.customFormToConnect.rollbackAttributes();
      }
    }

    this.customFormToConnect = null;
  }

  @computed('customForms.forms.[]')
  get hasCustomForms() {
    return this.customForms.hasConnectedOrDraftForms;
  }

  refetchForms = task(async () => {
    await this.customForms.fetchForms();
  });

  @action
  async onConnectForm(form: CustomForm) {
    await this.refetchForms.perform();

    this.args.onConnectForm?.(form);
  }

  constructor(owner: unknown, args: FormsSetupFormsCustomFormsArgs) {
    super(owner, args);

    this.customForms.initialize();
  }

  @action
  reportConnection() {
    if (this.args.setupGuideStatus == null || this.args.setupGuideOnSelect == null) {
      return;
    }

    if (this.args.setupGuideStatus !== 'complete' && this.customForms.hasConnectedOrDraftForms) {
      this.args.setupGuideOnSelect('forms', unixNowSeconds());
    }
  }
}
